import { render, staticRenderFns } from "./RoofView.vue?vue&type=template&id=a38da25a"
import script from "./RoofView.vue?vue&type=script&lang=ts"
export * from "./RoofView.vue?vue&type=script&lang=ts"
import style0 from "./RoofView.vue?vue&type=style&index=0&id=a38da25a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports